import React from 'react';
import { DisclaimerConfiguration } from '../typing/offer-disclaimer';
import { useSafeContext } from './use-safe-context';


export const DisclaimerConfigurationContext = React.createContext<
  DisclaimerConfiguration | undefined
>(undefined);

export function useDisclaimerConfiguration(): DisclaimerConfiguration {
  const disclaimerConfiguration = useSafeContext(
    DisclaimerConfigurationContext, 'disclaimerConfiguration'
  );

  return disclaimerConfiguration;
}
